import saveAs from "file-saver";
import JSZip from "jszip";

export const addDocumentToZip = async (
  zip: JSZip,
  doc: any,
  existingFilenames: Set<string>
) => {
  try {
    const response = await fetch(doc.originalUrl);
    const blob = await response.blob();
    let filename = doc.fileName;

    if (existingFilenames.has(filename)) {
      const extIndex = filename.lastIndexOf(".");
      const name = filename.substring(0, extIndex);
      const ext = filename.substring(extIndex);

      let counter = 1;
      let newFilename = `${name}_${counter}${ext}`;

      while (existingFilenames.has(newFilename)) {
        counter++;
        newFilename = `${name}_${counter}${ext}`;
      }

      filename = newFilename;
    }

    existingFilenames.add(filename);

    zip.file(filename, blob);
  } catch (error) {
    console.error(`Failed to fetch document ${doc.name}:`, error);
  }
};

export const generateAndSaveZip = async (documents: any[]) => {
  if (documents.length === 0) return;

  if (documents.length === 1) {
    try {
      const response = await fetch(documents[0].originalUrl);
      const blob = await response.blob();
      saveAs(blob, documents[0].fileName);
    } catch (error) {
      console.error(`Failed to fetch document ${documents[0].name}:`, error);
    }
    return;
  }

  const zip = new JSZip();
  const existingFilenames = new Set<string>();

  for (const doc of documents) {
    await addDocumentToZip(zip, doc, existingFilenames);
  }

  zip.generateAsync({ type: "blob" }).then((content) => {
    saveAs(content, "documents.zip");
  });
};
